<template>
  <div class="base-wrap bg-white mt-5 mb-3" style="box-shadow: 0 0 5px 3px #ddd;" id="shop_cart">
    <el-steps :space="500" :active='activeIndex' finish-status="success" align-center class="pt-5 pb-5" v-if="StayNightInfo">
      <el-step title="提交订单" />
      <el-step title="等待确认" />
      <el-step title="订单支付" />
      <el-step title="订单完成" />
    </el-steps>
    <submit-order v-if="activeIndex === 0"/>
  </div>
</template>

<script>
  import {mapActions,mapState} from 'vuex'
  import SubmitOrder from './SubmitOrder'

  export default {
    name: 'ShopCart',
    data() {
      return {
        activeIndex: 0,                                //当前进行的步骤条
      }
    },
    computed:{
      ...mapState(['StayNightInfo']),
    },
    components: {SubmitOrder},
    created() {
      this.GetShopCartInfo({
        type: '5'
      });
    },
    methods: {
      ...mapActions(['GetShopCartInfo']),
    }
  }
</script>
